import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { siteSignInUrl } from "../session";
import AuthFrame from "./AuthFrame";

import type { AuthMode } from "../types";

/* This app's /login and /signup when the marketing site holds the sign-in page (SIGN_IN_SITE):
   off to the site's, which sends them back to the page that sent them here once they are
   signed in. Every way out of a session lands here (RequireAuth, signOut, a 401 nobody could
   recover), so all of them reach the one sign-in page. */
export default function SignInOnSite({
  site,
  mode,
  leave = (url) => window.location.replace(url),
}: {
  site: string;
  mode: AuthMode;
  /** Tests watch where it goes; the app replaces the page. */
  leave?: (url: string) => void;
}) {
  const [params] = useSearchParams();
  // StrictMode runs effects twice in dev, and the kept return path is used up the first time.
  const left = useRef(false);

  useEffect(() => {
    if (left.current) return;
    left.current = true;
    leave(siteSignInUrl(site, mode, params));
  }, [site, mode, params, leave]);

  return (
    <AuthFrame>
      <span className="shimmer-text text-[13px] font-medium tracking-[-0.005em]">Taking you to sign in…</span>
    </AuthFrame>
  );
}
